module.exports = "../images/fishing-lodge-3-10.jpg?v=aa3d64a";